// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ServiceEpisodes_pageContent__PfHy4 {
  width: 100%;
  padding-left: 3rem;
  padding-right: 3rem;
}

.ServiceEpisodes_title__vJASe {
  font-weight: 700;
  font-size: 24px;
  line-height: 32.68px;
  color: #383838;
  margin-top: 1rem;
}

.ServiceEpisodes_actionButton__Ol8-j {
  display: inline-flex !important;
  cursor: pointer !important;
  color: #873caa;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.79px;
  padding: 16px 24px 16px 24px;
  border: 1px solid #873caa;
  border-radius: 28px;
  background-color: transparent;
}

.ServiceEpisodes_dischargeBtn__8BQ\\+D {
  border: 1px solid #873caa;
  border-radius: 28px;

  .p-inputtext {
    color: #873caa !important;
  }

  .p-dropdown .p-dropdown-trigger {
    color: #873caa !important;
  }

  .p-dropdown-trigger-icon {
    color: #873caa !important;
  }
}

.ServiceEpisodes_dischargeBtnDropdown__lJc2O {
  .p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus {
    background: white;
    font-weight: 700;
  }

  .p-dropdown-items .p-dropdown-item.p-highlight.p-focus {
    background: white !important;
  }

  .p-dropdown-items-wrapper {
    border-radius: 4px;
    border: none;
    box-shadow: -2px 0 1px -2px rgba(0, 0, 0, 0.2), 1px 0 1px -2px rgba(0, 0, 0, 0.2), 0 2px 4px -2px rgba(0, 0, 0, 0.2) !important;
  }

  .p-dropdown-trigger-icon {
    color: #873caa !important;
  }

  .p-dropdown-item-label {
    color: #873caa !important;
  }
}

.ServiceEpisodes_dialogHeader__h3aGA {
  font-weight: 700;
  font-size: 12px;
  line-height: 16.34px;
  color: #383838;
}

.ServiceEpisodes_dialogBody__IdwlP h3 {
  font-weight: 400;
  font-size: 12px;
  line-height: 16.34px;
}

.ServiceEpisodes_roundedButton__MwFlH {
  border-radius: 28px;
  padding: 12px 20px 12px 20px;
  font-size: 16px;
  font-weight: 600;
  line-height: 21.79px;
}

.ServiceEpisodes_secondaryButton__2URx6 {
  background-color: white;
  color: #873caa;
}

.ServiceEpisodes_dialog__MLUEX {
  width: 15vw;
  min-width: 300px;
}

.ServiceEpisodes_dialogActions__Be17o {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 2rem;
}

/* Mobile */
@media (max-width: 767px) {
  .ServiceEpisodes_dialog__MLUEX {
    width: 70vw;
    max-width: 335px;
  }

  .ServiceEpisodes_dialogActions__Be17o {
    flex-direction: column-reverse;
    gap: 0.5rem;
  }

  .ServiceEpisodes_roundedButton__MwFlH {
    width: 100%;
  }


}

.ServiceEpisodes_status__4bh1n {
  border-radius: 6px;
  padding: 3.5px 5.6px 3.5px 5.6px;
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
}

.ServiceEpisodes_statusClosed__KnyBS {
  background-color: var(--branded-traffic-red-bg);
  color: var(--branded-traffic-red);
}

.ServiceEpisodes_statusOpen__Db0ps {
  background-color: var(--branded-traffic-green-bg);
  color: var(--branded-traffic-green);
}

.ServiceEpisodes_statusPending__y\\+TQW {
  background-color: var(--branded-traffic-yellow-bg);
  color: var(--branded-traffic-yellow);
}`, "",{"version":3,"sources":["webpack://./src/styles/ServiceEpisodes.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,0BAA0B;EAC1B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;;EAEnB;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,kBAAkB;IAClB,YAAY;IACZ,+HAA+H;EACjI;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,4BAA4B;EAC5B,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA,WAAW;AACX;EACE;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;;AAGF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,+CAA+C;EAC/C,iCAAiC;AACnC;;AAEA;EACE,iDAAiD;EACjD,mCAAmC;AACrC;;AAEA;EACE,kDAAkD;EAClD,oCAAoC;AACtC","sourcesContent":[".pageContent {\n  width: 100%;\n  padding-left: 3rem;\n  padding-right: 3rem;\n}\n\n.title {\n  font-weight: 700;\n  font-size: 24px;\n  line-height: 32.68px;\n  color: #383838;\n  margin-top: 1rem;\n}\n\n.actionButton {\n  display: inline-flex !important;\n  cursor: pointer !important;\n  color: #873caa;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 21.79px;\n  padding: 16px 24px 16px 24px;\n  border: 1px solid #873caa;\n  border-radius: 28px;\n  background-color: transparent;\n}\n\n.dischargeBtn {\n  border: 1px solid #873caa;\n  border-radius: 28px;\n\n  :global(.p-inputtext) {\n    color: #873caa !important;\n  }\n\n  :global(.p-dropdown .p-dropdown-trigger) {\n    color: #873caa !important;\n  }\n\n  :global(.p-dropdown-trigger-icon) {\n    color: #873caa !important;\n  }\n}\n\n.dischargeBtnDropdown {\n  :global(.p-dropdown-items .p-dropdown-item:not(.p-highlight):not(.p-disabled).p-focus) {\n    background: white;\n    font-weight: 700;\n  }\n\n  :global(.p-dropdown-items .p-dropdown-item.p-highlight.p-focus) {\n    background: white !important;\n  }\n\n  :global(.p-dropdown-items-wrapper) {\n    border-radius: 4px;\n    border: none;\n    box-shadow: -2px 0 1px -2px rgba(0, 0, 0, 0.2), 1px 0 1px -2px rgba(0, 0, 0, 0.2), 0 2px 4px -2px rgba(0, 0, 0, 0.2) !important;\n  }\n\n  :global(.p-dropdown-trigger-icon) {\n    color: #873caa !important;\n  }\n\n  :global(.p-dropdown-item-label) {\n    color: #873caa !important;\n  }\n}\n\n.dialogHeader {\n  font-weight: 700;\n  font-size: 12px;\n  line-height: 16.34px;\n  color: #383838;\n}\n\n.dialogBody h3 {\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16.34px;\n}\n\n.roundedButton {\n  border-radius: 28px;\n  padding: 12px 20px 12px 20px;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 21.79px;\n}\n\n.secondaryButton {\n  background-color: white;\n  color: #873caa;\n}\n\n.dialog {\n  width: 15vw;\n  min-width: 300px;\n}\n\n.dialogActions {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 2rem;\n}\n\n/* Mobile */\n@media (max-width: 767px) {\n  .dialog {\n    width: 70vw;\n    max-width: 335px;\n  }\n\n  .dialogActions {\n    flex-direction: column-reverse;\n    gap: 0.5rem;\n  }\n\n  .roundedButton {\n    width: 100%;\n  }\n\n\n}\n\n.status {\n  border-radius: 6px;\n  padding: 3.5px 5.6px 3.5px 5.6px;\n  font-size: 12px;\n  font-weight: 600;\n  line-height: 18px;\n}\n\n.statusClosed {\n  background-color: var(--branded-traffic-red-bg);\n  color: var(--branded-traffic-red);\n}\n\n.statusOpen {\n  background-color: var(--branded-traffic-green-bg);\n  color: var(--branded-traffic-green);\n}\n\n.statusPending {\n  background-color: var(--branded-traffic-yellow-bg);\n  color: var(--branded-traffic-yellow);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageContent": `ServiceEpisodes_pageContent__PfHy4`,
	"title": `ServiceEpisodes_title__vJASe`,
	"actionButton": `ServiceEpisodes_actionButton__Ol8-j`,
	"dischargeBtn": `ServiceEpisodes_dischargeBtn__8BQ+D`,
	"dischargeBtnDropdown": `ServiceEpisodes_dischargeBtnDropdown__lJc2O`,
	"dialogHeader": `ServiceEpisodes_dialogHeader__h3aGA`,
	"dialogBody": `ServiceEpisodes_dialogBody__IdwlP`,
	"roundedButton": `ServiceEpisodes_roundedButton__MwFlH`,
	"secondaryButton": `ServiceEpisodes_secondaryButton__2URx6`,
	"dialog": `ServiceEpisodes_dialog__MLUEX`,
	"dialogActions": `ServiceEpisodes_dialogActions__Be17o`,
	"status": `ServiceEpisodes_status__4bh1n`,
	"statusClosed": `ServiceEpisodes_statusClosed__KnyBS`,
	"statusOpen": `ServiceEpisodes_statusOpen__Db0ps`,
	"statusPending": `ServiceEpisodes_statusPending__y+TQW`
};
export default ___CSS_LOADER_EXPORT___;
